import * as React from "react";
import {
  List, Datagrid, TextField, FunctionField, useRecordContext,
} from "react-admin";
import { Box } from "@mui/material";
import { ConfirmActionButton } from "../../components/ConfirmActionButton";
import { EnumChip } from "../../components/EnumChip";
import { InfoGrid } from "../../components/InfoGrid";
import { SUGGESTION_STATUS } from "../../enums";
import { httpClient } from "../../api/httpClient";
import { API_BASE_URL } from "../../api/config";
import { FrDateField } from "../../components/FrDateField";

// AdminSuggestionsController : GET /admin/suggestions/jobs (suggestions EN
// ATTENTE uniquement, sans filtre), PUT …/{id}/approve, PUT …/{id}/reject.
// Ni GET /{id} ni PUT /{id} : pas de fiche ni d'édition — le détail se
// déplie dans la liste (une suggestion traitée disparaît de la liste).

const Approve = () => {
  const r = useRecordContext();
  if (!r || r.status === "VALIDATED") return null;
  return (
    <ConfirmActionButton label="Approuver" color="success"
      confirmTitle="Approuver" confirmText={`Approuver "${r.jobName}" ?`}
      successMessage="Approuvé"
      onConfirm={() => httpClient(`${API_BASE_URL}/admin/suggestions/jobs/${r.id}/approve`, { method: "PUT", body: JSON.stringify({}) })}
    />
  );
};
const Reject = () => {
  const r = useRecordContext();
  if (!r || r.status === "REJECTED") return null;
  return (
    <ConfirmActionButton label="Rejeter" color="error"
      confirmTitle="Rejeter" confirmText={`Rejeter "${r.jobName}" ?`}
      successMessage="Rejeté"
      onConfirm={() => httpClient(`${API_BASE_URL}/admin/suggestions/jobs/${r.id}/reject`, { method: "PUT", body: JSON.stringify({}) })}
    />
  );
};

const Detail = () => (
  <Box sx={{ p: 1 }}>
    <InfoGrid
      fields={[
        { label: "ID", source: "id", type: "mono" },
        { label: "Nom du métier proposé", source: "jobName" },
        { label: "Commentaire / motivation", source: "comment" },
        { label: "Proposé par (nom)", source: (r) => r?.suggestedByName || "—" },
        { label: "Proposé par (email)", source: "suggestedByEmail" },
        { label: "Proposé par (user ID)", source: "suggestedBy", type: "mono" },
        { label: "Email de contact (déclaré)", source: "contactEmail" },
        { label: "Statut", source: "status" },
        { label: "Proposé le", source: "createdAt", type: "datetime" },
      ]}
    />
  </Box>
);

export default {
  list: () => (
    <List>
      <Datagrid rowClick="expand" expand={<Detail />} bulkActionButtons={false}>
        <TextField source="jobName" label="Métier proposé" />
        <FunctionField label="Proposé par" render={(r) => {
          const name = r?.suggestedByName;
          const email = r?.suggestedByEmail;
          const id = r?.suggestedBy;
          if (!id) return "—";
          return (
            <a href={`#/users/${id}/show`} style={{ color: "#0d7377", fontWeight: 600 }}>
              {name || id}{email ? ` (${email})` : ""}
            </a>
          );
        }} />
        <TextField source="contactEmail" label="Contact" />
        <EnumChip source="status" enumObj={SUGGESTION_STATUS} />
        <FrDateField source="createdAt" label="Proposé le" showTime />
        <FunctionField label="Actions" render={() => (
          <Box sx={{ display: "flex", gap: 1 }} onClick={(e) => e.stopPropagation()}>
            <Approve />
            <Reject />
          </Box>
        )} />
      </Datagrid>
    </List>
  ),
};
